// frontend/klaes-app/src/components/FilmFavs/components/RatingPopup.jsx
import { useState } from 'react';
import { FiX, FiCheck } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import styles from '../FilmFavs.module.css';

export const RatingPopup = ({ onRate, onClose, currentRating }) => {
  const [tempRating, setTempRating] = useState(currentRating || 50);

  return (
    <div className={styles.ratingPopup}>
      <div className={styles.ratingPopupHeader}>
        <span>Deine Bewertung bearbeiten</span>
        <button 
          onClick={onClose} 
          className={styles.ratingPopupCloseBtn}
          aria-label="Schließen"
        >
          <FiX />
        </button>
      </div>
      <input 
        type="range" 
        min="0" 
        max="100" 
        step="0.1" 
        value={tempRating}
        onChange={(e) => setTempRating(parseFloat(e.target.value))}
        className={styles.ratingSlider}
      />
      <div className={styles.ratingValue}>{tempRating.toFixed(1)}%</div>
      <BatteryIndicator rating={tempRating} isUserRating />
      <button onClick={() => onRate(tempRating)} className={styles.ratingSubmit}>
        <FiCheck /> Bewertung aktualisieren
      </button>
    </div>
  );
};